import React, { useState, useEffect } from "react";
import Button from "../components/Button";
import styles from "./AddOtherFoodModal.module.css";
import { validateForm, validateInput } from "../helpers/helperFunctions";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { flashAlert } from "../global_js";
import EventMenu from "../menus/EventMenu";

function AddOtherFoodModal({ eventData, setEventData, getServers, bID, makeInvalid, categories }) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen((x) => !x);
  };
  const closeModal = () => {
    setIsOpen((x) => !x);
  };

  const [description, setDescription] = useState("");
  const [price, setPrice] = useState(0.0);
  const [qty, setQty] = useState(1);
  const [type, setType] = useState("APP");

  const addOtherFoodItem = async (e) => {
    e.preventDefault();
    if (validateForm(e.target)) {
      const formData = new URLSearchParams({
        id: bID,
        description: description,
        price: price,
        qty: qty,
        type: type,
        gratPercent: eventData.percentGrat,
        pricePerTotal: qty * price,
        userId: JSON.parse(localStorage.getItem("userLogin")).userId,
      });

      await fetch("/api/detail/addotherfood", {
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          setEventData({
            ...eventData,
            serviceTotal: data.priceUpdate.serviceTotal,
            fbTotal: data.priceUpdate.fbTotal,
            barTotal: data.priceUpdate.barTotal,
            details: data.details,
          });
          getServers();
        });

      closeModal();
    }
  };

  return (
    <>
      <Button type="tertiary" onClick={openModal}>
        Add Other Food Item
      </Button>
      {isOpen && (
        <div className="modal-backdrop modal-backdrop-dark">
          <div className={`modal-content ${styles.modalTop}`}>
            <h3 className="modal-header">Add Other Food Item</h3>

            <form className={styles.otherMenuItemForm} onSubmit={addOtherFoodItem} noValidate>
              <h4>Add other menu item</h4>
              <div className={styles.otherMenuItemBody}>
                <div className={styles.formSection}>
                  <input
                    type="text"
                    name="description"
                    className={styles.otherDesc}
                    placeholder="Enter description"
                    onChange={(e) => setDescription(e.target.value)}
                    required
                    onInvalid={makeInvalid}
                  />
                  <div className="invalid-feedback">Item description required</div>
                </div>
                <div className={styles.formSection}>
                  <select style={{ width: "100%" }} name="type" onChange={(e) => setType(e.target.value)} value={type}>
                    {categories
                      .filter((item) => !item.id.includes("_") && item.id != "SIDE" && item.id != "OFI")
                      .map((selection) => {
                        return <option value={selection.id}>{selection.descriptions}</option>;
                      })}
                  </select>
                </div>
                <div className={styles.formSection}>
                  <input
                    type="number"
                    name="price"
                    className={styles.otherPrice}
                    step=".01"
                    placeholder="Enter price"
                    onChange={(e) => setPrice(e.target.value)}
                    required
                    onInvalid={makeInvalid}
                  />
                  <div className="invalid-feedback">Item price required</div>
                </div>
                {/* <div className={styles.formSection}>
                  <input
                    type="number"
                    name="qty"
                    className={styles.otherQty}
                    placeholder="Enter quantity"
                    onChange={(e) => setQty(e.target.value)}
                    required
                    onInvalid={makeInvalid}
                  />
                  <div className="invalid-feedback">Item quantity required</div>
                </div> */}
                <Button type="secondary">Add Other Item</Button>
              </div>
            </form>
            <div className={styles.formSelectButtons}>
              {/* <Button type="primary">Save</Button> */}
              <Button type="save" onClick={closeModal}>
                Close
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddOtherFoodModal;
